"use strict";

Shopify.theme.jsBenefitsSlider = {
  init: function init($section) {
    var $benefitsSliderEl = $section.find('[data-benefits-slider]');
    var $prevButton = $section.find('.benefits__nav--prev');
    var $nextButton = $section.find('.benefits__nav--next');
    var $benefitsSlider = $benefitsSliderEl.flickity({
      wrapAround: false,
      draggable: true,
      prevNextButtons: false,
      adaptiveHeight: true,
      pageDots: true,
      imagesLoaded: true,
      on: {
        ready: function ready() {
          setTimeout(function () {
            $benefitsSlider.flickity('resize');
            updateNavButtonState();
          }, 500);
        }
      }
    });
    // Change slide on nav button click
    $prevButton.on('click', function () {
      $benefitsSlider.flickity('previous');
    });
    // Change slide on nav button click
    $nextButton.on('click', function () {
      $benefitsSlider.flickity('next');
    });
    // Add is-disabled class to nav buttons when first/last slide active
    $benefitsSlider.on( 'change.flickity', function() {
      updateNavButtonState();
    });

    function updateNavButtonState() {
      var $sliderData = $benefitsSlider.data('flickity');
      var $selectedIndex = $sliderData.selectedIndex;
      var $sliderLength =  $sliderData.slides.length;
      var $isFirstSlide = $selectedIndex === 0;
      var $isLastSlide = $selectedIndex === $sliderLength - 1;
      if ($isFirstSlide) {
        $prevButton.addClass('is-disabled');
      } else {
        $prevButton.removeClass('is-disabled');
      }
      if($isLastSlide) {
        $nextButton.addClass('is-disabled');
      } else {
        $nextButton.removeClass('is-disabled');
      }
    }
  },
  blockSelect: function blockSelect($section, blockId) {
    var $slider = $section.find('[data-benefits-slider]');
    var $sliderIndex = $('#shopify-section-' + blockId).data('data-slide-index');
    $slider.flickity('select', $sliderIndex, true, true);
  },
  unload: function unload($section) {
    var $slider = $section.find('.flickity-enabled');
    $slider.flickity('destroy');
    $('.benefits__nav--prev').off();
    $('.benefits__nav--next').off();
  }
};